import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useUser } from "@/context/user-context";
import { ENDPOINTS } from "@/api/application-api";
import { displayErrorToast } from "@/utils/toast";
import { useAuth } from "@/context/auth-context";
import { jsonAuthHeaders } from "@/utils/headers";

export const useUpdateUser = () => {
  const { user } = useUser();
  const auth = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { name: string }) =>
      fetch(ENDPOINTS.update_user(user?.id), {
        method: "PATCH",
        body: JSON.stringify(data),
        headers: jsonAuthHeaders(auth?.userToken ?? ""),
      }).then(res => res.json()),
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ["user"] });
      auth?.updateUserState(data);
    },
    onError: (error: Error) => {
      displayErrorToast(error.message);
    },
  });
};
